// import "./TFDAccelerateNationalTours.css";
import "./AccelerateGlobal.css";

import { Link } from "react-router-dom";
import React from "react";

export default function TFDAccelerateNationalTours() {
  return (
    <div className="tfd-accelerate-national-tours-page">
      {/* HERO SECTION */}
      <section className="tf-hero-national-tours">
        <div className="hero-image-wrap">
          <img
            src="/images/accelerate/national-tours-hero.jpg"
            alt="National Tours Hero"
            className="hero-bg-image"
          />
          <div className="overlay-dark" />
          <div className="hero-content themeflat-container">
            <h1 className="hero-title wow fadeInUp animated">
              TFD ACCELERATE National Tours
            </h1>
            <p className="hero-subtitle wow fadeInUp animated">
              Experience football excellence across Australia.
            </p>
            <Link to="/contact" className="flat-button wow fadeInUp animated">
              Join the Tour
            </Link>
          </div>
        </div>
      </section>

      {/* TIMELINE SECTION */}
      <section className="tf-national-tours-timeline main-content">
        <div className="themeflat-container">
          <div className="timeline">
            {/* Timeline Item 1 */}
            <div className="timeline-item wow fadeInUp animated">
              <div className="timeline-image">
                <img
                  src="/images/accelerate/national-tour1.jpg"
                  alt="Melbourne Marathon of Skills"
                />
              </div>
              <div className="timeline-content">
                <h3 className="timeline-title">Melbourne Marathon of Skills</h3>
                <span className="timeline-date">March 10, 2025</span>
                <p className="timeline-desc">
                  Kick off the national tour in Melbourne with an exciting showcase of emerging talent and advanced drills.
                </p>
              </div>
            </div>
            {/* Timeline Item 2 */}
            <div className="timeline-item wow fadeInUp animated" data-wow-delay="0.2s">
              <div className="timeline-image">
                <img
                  src="/images/accelerate/national-tour2.jpg"
                  alt="Sydney Skill Showcase"
                />
              </div>
              <div className="timeline-content">
                <h3 className="timeline-title">Sydney Skill Showcase</h3>
                <span className="timeline-date">April 5, 2025</span>
                <p className="timeline-desc">
                  In Sydney, young athletes refine their technique with world-class coaching and competitive drills.
                </p>
              </div>
            </div>
            {/* Timeline Item 3 */}
            <div className="timeline-item wow fadeInUp animated" data-wow-delay="0.4s">
              <div className="timeline-image">
                <img
                  src="/images/accelerate/national-tour3.jpg"
                  alt="Brisbane Bootcamp"
                />
              </div>
              <div className="timeline-content">
                <h3 className="timeline-title">Brisbane Bootcamp</h3>
                <span className="timeline-date">May 20, 2025</span>
                <p className="timeline-desc">
                  Experience an intensive bootcamp in Brisbane focused on tactical awareness, endurance, and leadership.
                </p>
              </div>
            </div>
            {/* Additional timeline items can be added here */}
          </div>
        </div>
      </section>

      {/* CTA SECTION */}
      <section className="tf-national-tours-cta main-content">
        <div className="themeflat-container text-center">
          <Link to="/contact" className="flat-button big-cta-button wow fadeInUp animated">
            Become a Part of the Journey
          </Link>
        </div>
      </section>
    </div>
  );
}
